import { ResponseVM } from 'src/app/shared/models/model/concretes/components/response.model';
import { PopUpInfoVM } from './popup-info.model';
export class QuestionVM {
  libelle: string;
  responseVMs?: ResponseVM[];
  popupInfo?: PopUpInfoVM;
  id?: number;

  constructor(libelle: string, popupInfo?: PopUpInfoVM, responseVMs?: ResponseVM[], id?: number) {
    this.libelle = libelle;
    this.popupInfo = popupInfo;
    this.responseVMs = responseVMs;
    this.id = id;
  }
}
